export const stripPlanWord = (title) => {
  if (!title) {
    return '';
  }
  return title.replace('Plan', '');
}